const SET_PIKE13_DATA = 'venuePortal/pike13Migration/SET_PIKE13_DATA';
const SET_PIKE13_DATA_FROM_LOCAL_STORAGE = 'venuePortal/pike13Migration/SET_PIKE13_DATA_FROM_LOCAL_STORAGE';
const SET_PIKE13_IS_LOADING = 'venuePortal/pike13Migration/SET_PIKE13_IS_LOADING';

export const setPike13Data = payload => ({ type: SET_PIKE13_DATA, payload });
export const setPike13DataFromLocalStorage = payload => ({ type: SET_PIKE13_DATA_FROM_LOCAL_STORAGE, payload });
export const setPike13IsLoading = payload => ({ type: SET_PIKE13_IS_LOADING, payload });
export const setPike13ApiToken = apiToken => ({ type: SET_PIKE13_DATA, payload: { apiToken } });

export const initialPike13State = {
  localStorageData: {},
  lastReservationDate: undefined,
  locations: undefined,
  services: undefined,
  isLoading: {
    lastReservationDate: false,
    pike13Data: false,
    migration: false,
  },
  isSuccess: false,
  apiToken: '',
};

export default (state = initialPike13State, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PIKE13_DATA:
      return {
        ...state,
        ...payload,
      };

    case SET_PIKE13_DATA_FROM_LOCAL_STORAGE:
      return {
        ...state,
        localStorageData: {
          ...state.localStorageData,
          ...payload,
        },
      };

    case SET_PIKE13_IS_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          ...payload,
        },
      };

    default:
      return state;
  }
};
